import { render, staticRenderFns } from "./DischargeFormModal.vue?vue&type=template&id=07bb37fe&scoped=true&"
import script from "./DischargeFormModal.vue?vue&type=script&lang=js&"
export * from "./DischargeFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bb37fe",
  null
  
)

export default component.exports